<template>
  <BottomDrawer
    v-model="visible"
    :draggable="true"
    :close-threshold="100"
    :close-on-click-mask="true"
    :lock-scroll="true"
    class="m-only"
    @close="handleClose"
  >
    <div v-if="userInfo" class="user-pop__content">
      <!-- 账号区域 -->
      <div class="user-pop__account">
        <p class="user-pop__label">Account</p>
        <div class="user-pop__user-row">
          <div class="user-pop__user-info">
            <Resource
              :src="userInfo.logo_url"
              :transform-resource="transformImage"
              class="user-pop__avatar"
              alt="avatar"
            />
            <p class="user-pop__user-name">
              {{ userInfo.account_name }}
            </p>
          </div>

          <RightTag
            v-if="userInfo?.rights_type"
            class="user-pop__level-tag"
            :rights-type="userInfo.rights_type"
          />
        </div>
        <div class="user-pop__divider"></div>
      </div>

      <!-- 列表区域 -->
      <div class="user-pop__list">
        <div class="user-pop__list-item user-pop__list-item--logout" @click="handleLogout">
          <span class="user-pop__list-text">Logout</span>
        </div>
      </div>

      <!-- 按钮区域 -->
      <div class="user-pop__btn-section">
        <div class="user-pop__btn-group">
          <Button
            variant="border-back"
            size="large"
            class="user-pop__btn user-pop__btn--outline"
            @click="handleConsult"
          >
            Contact Us
          </Button>
          <Button
            variant="purple"
            size="large"
            class="user-pop__btn user-pop__btn--primary"
            @click="handleGoPC"
          >
            Switch to desktop for full features
          </Button>
        </div>
        <p class="user-pop__hint">Copy the link or search Rendora on desktop.</p>
      </div>
    </div>
  </BottomDrawer>
</template>

<script lang="ts" setup>
import BottomDrawer from '@rendora/design/components/bottom-drawer/BottomDrawer.vue';
import Button from '@rendora/design/components/button/Button.vue';
import RightTag from '@rendora/common/features/right-tag/index.vue';
import { message } from 'ant-design-vue';
import Resource from '~/components/resource';
import { useLoginOut } from '~/composables/user';
import { USER_LEVEL } from '~/constants';
import { showContact } from '~/hooks/useModal/modals/contact';
import { transformImage } from '~/utils';
import { copy } from '~/utils/copy';

const userInfo = useUserInfo();

const visible = ref(false);

const levelInfo = computed(() => {
  const rightsType = userInfo.value?.rights_type;
  if (!rightsType) return null;
  const levels = USER_LEVEL();
  return levels[rightsType];
});

const levelTagStyle = computed(() => {
  if (!levelInfo.value) return {};
  return {
    background: levelInfo.value.background,
    color: levelInfo.value.textColor,
  };
});

const open = () => {
  visible.value = true;
};

const close = () => {
  visible.value = false;
};

const handleClose = () => {
  visible.value = false;
};

const handleLogout = async () => {
  close();
  await useLoginOut();
  navigateTo('/login');
};

const handleConsult = () => {
  showContact();
  close();
};

const handleGoPC = async () => {
  const url = window.location.origin;
  try {
    await copy(url);
    message.success('Link copied! Please log in on your computer.');
  } catch (_e) {
    message.info('Failed to copy the link. Please search “Rendora” in your computer browser.');
  }
  close();
};

defineExpose({
  open,
  close,
});
</script>

<style lang="scss" scoped src="./mobile.scss"></style>
